import { Navigate, Route, Routes } from "react-router-dom";

import { AuthLayout } from "@/layout";
import {
  ActivePatient,
  DisqualifiedPatient,
  EndScreenDisqualified,
  EndScreenRegistered,
  EndScreenTransferred,
  Login,
  PatientsList,
  SignUp,
  TwoFactorAuthChallenge,
  TwoFactorAuthSetup,
} from "@/screens";
import { ForgotPassword } from "@/screens/ForgotPassword";
import { NewIntake } from "@/screens/NewIntake";
import { ResetPassword } from "@/screens/ResetPassword";
import { TransferredPatient } from "@/screens/TransferredPatient";
import { useUserStore } from "@/stores";
import { AGENT_ROLES } from "@/utils";
import { PublicRoute } from "./PublicRoute";
import { RoleProtectedRoute } from "./RoleProtectedRoute";
import { ROUTES } from "./routes";

function RootRedirect() {
  const { token, isTwoFaAuthenticated, user } = useUserStore();
  const isAuthenticated = Boolean(token && isTwoFaAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} replace />;
  }
  switch (user?.role) {
    case AGENT_ROLES.CALL_CENTER_AGENT:
      return <Navigate to={ROUTES.newIntake} replace />;
    case AGENT_ROLES.DATA_ENTRY_AGENT:
      return <Navigate to={ROUTES.casesList} replace />;
    case AGENT_ROLES.ADMINISTRATOR:
      return <Navigate to={ROUTES.casesList} replace />;
    default:
      return <Navigate to={ROUTES.login} replace />;
  }
}

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />

      <Route element={<PublicRoute />}>
        <Route path="/" element={<AuthLayout />}>
          <Route path={ROUTES.login} element={<Login />} />
          <Route path={ROUTES.forgotPassword} element={<ForgotPassword />} />
          <Route path={ROUTES.resetPassword} element={<ResetPassword />} />
          <Route path={ROUTES.signUp} element={<SignUp />} />
          <Route
            path={ROUTES.twoFactorAuthSetup}
            element={<TwoFactorAuthSetup />}
          />
          <Route
            path={ROUTES.twoFactorAuthChallenge}
            element={<TwoFactorAuthChallenge />}
          />
        </Route>
      </Route>

      <Route
        element={<RoleProtectedRoute roles={[AGENT_ROLES.CALL_CENTER_AGENT]} />}
      >
        <Route path={ROUTES.newIntake} element={<NewIntake />} />
        <Route path={ROUTES.activePatient} element={<ActivePatient />} />
        <Route
          path={ROUTES.disqualifiedPatient}
          element={<DisqualifiedPatient />}
        />
        <Route
          path={ROUTES.transferredPatient}
          element={<TransferredPatient />}
        />
        <Route
          path={ROUTES.endScreenRegistered}
          element={<EndScreenRegistered />}
        />
        <Route
          path={ROUTES.endScreenDisqualified}
          element={<EndScreenDisqualified />}
        />
        <Route
          path={ROUTES.endScreenTransferred}
          element={<EndScreenTransferred />}
        />
      </Route>

      <Route
        element={
          <RoleProtectedRoute
            roles={[AGENT_ROLES.DATA_ENTRY_AGENT, AGENT_ROLES.ADMINISTRATOR]}
          />
        }
      >
        <Route path={ROUTES.casesList} element={<PatientsList />} />
      </Route>

      <Route path="*" element={<Navigate to={ROUTES.newIntake} replace />} />
    </Routes>
  );
};
